import type { MiscData } from './types';

export const miscDataDTO = (data: unknown): MiscData | null => {
  if (data && typeof data === 'object') {
    return {
      transfer_type:
        'transfer_type' in data && typeof data.transfer_type === 'string'
          ? data.transfer_type
          : undefined,
      bundle_id:
        'bundle_id' in data && typeof data.bundle_id === 'string'
          ? data.bundle_id
          : undefined,
      book_hash:
        'book_hash' in data && typeof data.book_hash === 'string'
          ? data.book_hash
          : undefined,
      acm_component_id:
        'acm_component_id' in data && typeof data.acm_component_id === 'string'
          ? data.acm_component_id
          : undefined,
      supplier_id:
        'supplier_id' in data && typeof data.supplier_id === 'number'
          ? data.supplier_id
          : undefined,
      claimId:
        'claimId' in data && typeof data.claimId === 'string'
          ? data.claimId
          : undefined,
      programType:
        'programType' in data && typeof data.programType === 'string'
          ? data.programType
          : undefined,
      extra_beds_content:
        'extra_beds_content' in data ? data.extra_beds_content : undefined,
      op_search_url:
        'op_search_url' in data && typeof data.op_search_url === 'string'
          ? data.op_search_url
          : undefined,
      route_component_id:
        'route_component_id' in data &&
        typeof data.route_component_id === 'string'
          ? data.route_component_id
          : undefined,
    };
  }

  return null;
};
